import {
  PaintRoller,
  Fence,
  HardHat,
  Layers,
  Bath,
  ChefHat,
  Siren,
  DoorClosed,
  LayoutGrid,
  Grid3x3,
} from "lucide-react";

export const PHONE_DISPLAY = "(706) 897-8366";
export const PHONE_TEL = "+17068978366";
export const EMAIL = "contact@journeyshandyman.com";
export const EMAIL2 = "stevecarnes@journeyshandyman.com";
export const LOGO =
  "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/4f5rukmq_IMG_5078.png";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?q=80&w=1600&auto=format&fit=crop";
export const AREAS_IMG =
  "https://images.pexels.com/photos/18013526/pexels-photo-18013526.jpeg?auto=compress&cs=tinysrgb&w=1600";
export const WHY_IMG =
  "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/7q05yzph_IMG_5088.jpeg";

export const SERVICES = [
  {
    id: "painting",
    icon: PaintRoller,
    title: "Interior & Exterior Painting",
    desc: "Fresh, durable finishes inside and out. Trusted local handyman painters for walls, trim, cabinets, decks and full exteriors across North Georgia.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/2qxofs55_IMG_4916.jpeg",
  },
  {
    id: "decks",
    icon: Fence,
    title: "Decks & Railing",
    desc: "New deck builds, board replacement, staining and safe, code-ready railing so you can enjoy those Blue Ridge mountain views.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/jgqlo19o_IMG_4928.jpeg",
  },
  {
    id: "roofing",
    icon: HardHat,
    title: "Roof Life Extension",
    desc: "Roof repairs, resealing and protective roof coating that add years of life to your shingles — a smart, affordable alternative to a full replacement.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/kgf2ouuy_IMG_5079.jpeg",
  },
  {
    id: "basement",
    icon: Layers,
    title: "Basement Finishing",
    desc: "Turn unused space into a family room, office or rental suite with framing, drywall, flooring and lighting done right.",
    image:
      "https://images.pexels.com/photos/35539075/pexels-photo-35539075.jpeg?auto=compress&cs=tinysrgb&w=1000",
  },
  {
    id: "bathroom",
    icon: Bath,
    title: "Bathroom Remodels",
    desc: "Modern tile showers, vanities, fixtures and full bathroom renovations built to last and to boost your home's value.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/9k8uclkd_IMG_5057.jpeg",
  },
  {
    id: "kitchen",
    icon: ChefHat,
    title: "Kitchen Remodels",
    desc: "Cabinets, countertops, backsplashes and layouts. Complete kitchen remodels that fit your budget and your mountain lifestyle.",
    image:
      "https://images.pexels.com/photos/36511371/pexels-photo-36511371.jpeg?auto=compress&cs=tinysrgb&w=1000",
  },
  {
    id: "cabinets",
    icon: DoorClosed,
    title: "Cabinets",
    desc: "Custom cabinet installation, refacing and repairs for kitchens, bathrooms, laundry rooms and built-ins — quality craftsmanship that lasts.",
    image:
      "https://images.pexels.com/photos/16501692/pexels-photo-16501692.jpeg?auto=compress&cs=tinysrgb&w=1000",
  },
  {
    id: "flooring",
    icon: LayoutGrid,
    title: "Flooring",
    desc: "Hardwood, laminate, luxury vinyl plank and tile flooring — expertly installed and finished to transform any room in your home.",
    image:
      "https://images.pexels.com/photos/1388944/floor-flooring-hand-man-1388944.jpeg?auto=compress&cs=tinysrgb&w=1000",
  },
  {
    id: "pavers",
    icon: Grid3x3,
    title: "Pavers",
    desc: "Paver patios, walkways and driveways built to handle North Georgia weather — durable, beautiful hardscapes for your outdoor spaces.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/641jmiof_IMG_4983.jpeg",
  },
  {
    id: "restoration",
    icon: Siren,
    title: "Emergency Restoration",
    desc: "Water, storm and fire damage cleanup and repair. Same-day response and 24/7 emergency restoration to get your home back fast.",
    image:
      "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/1mf7j2cn_IMG_4909.jpeg",
    emergency: true,
  },
];

export const RESTORATION_GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/1mf7j2cn_IMG_4909.jpeg",
    caption: "Commercial water damage — air movers deployed for rapid drying",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/lyvscydz_IMG_4910.jpeg",
    caption: "Water-damaged drywall & insulation demolition",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/zq5vja9g_IMG_4911.jpeg",
    caption: "Kitchen flood tear-out & plumbing repair",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/41tt70ec_IMG_4912.jpeg",
    caption: "Full sub-floor tear-out during restoration",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/rjgy120p_IMG_4913.jpeg",
    caption: "Structural drying after a water loss",
  },
];

export const PAINTING_GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/4cd0lzsk_IMG_4989.jpeg",
    caption: "Cedar-shake & board-and-batten exterior staining and finish",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/2qxofs55_IMG_4916.jpeg",
    caption: "Log cabin exterior staining — full refinish with new deck",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/suklsxg3_IMG_4915.jpeg",
    caption: "Fresh stain & sealed logs with black window trim",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/p20ua2bq_IMG_4919.jpeg",
    caption: "Rich, even stain across full log siding",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/12j0tz6b_IMG_4917.jpeg",
    caption: "Stained porch, ceiling and window trim detail",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/5rrrxdju_IMG_4918.jpeg",
    caption: "Wraparound porch staining and finish work",
  },
];

export const SERVICE_GALLERY = {
  painting: "painting",
  decks: "decks",
  roofing: "roof",
  pavers: "pavers",
  bathroom: "bathroom",
  restoration: "restoration",
};

export const GALLERY_TABS = [
  { key: "painting", label: "Painting & Staining" },
  { key: "decks", label: "Decks & Railing" },
  { key: "pavers", label: "Pavers" },
  { key: "roof", label: "Roof Life Extension" },
  { key: "restoration", label: "Emergency Restoration" },
];

export const PAVERS_GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/641jmiof_IMG_4983.jpeg",
    caption: "New paver patio with sealed stone finish",
  },
];

export const ROOF_GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/kgf2ouuy_IMG_5079.jpeg",
    caption: "Our roof coating rig — protective treatment to extend roof life",
  },
];

export const DECKS_GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/jgqlo19o_IMG_4928.jpeg",
    caption: "New lakeside deck with wire-panel railing",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_journeys-handyman/artifacts/9r02hbkg_IMG_4920.jpeg",
    caption: "Pressure-treated deck build in progress",
  },
];

export const AREAS = [
  "Blairsville, GA 30512",
  "Young Harris, GA",
  "Hiawassee, GA",
  "Blue Ridge, GA",
  "Murphy, NC",
  "Morganton, GA",
  "Suches, GA",
  "Mineral Bluff, GA",
  "McCaysville, GA",
  "Hayesville, NC",
  "Brasstown, NC",
  "Andrews, NC",
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    location: "Blairsville, GA",
    text: "Journey's repainted our whole cabin interior and rebuilt the back deck. Professional, on time, and the price was fair. Best handyman we've found in North Georgia.",
  },
  {
    name: "Dale R.",
    location: "Hiawassee, GA",
    text: "A pipe burst while we were away and they responded same day. The emergency restoration crew saved our floors. Cannot recommend them enough.",
  },
  {
    name: "Karen & Tom P.",
    location: "Young Harris, GA",
    text: "Our kitchen remodel turned out beautiful. Honest communication start to finish and they treated our home like their own.",
  },
  {
    name: "Mike D.",
    location: "Blue Ridge, GA",
    text: "Extended the life of our roof instead of pushing a full replacement. Saved us thousands. Reliable, local, and trustworthy.",
  },
];

export const FAQS = [
  {
    q: "How much does a handyman cost in Blairsville, GA?",
    a: "Every project is different, so we provide free, no-obligation estimates. Small repairs are billed hourly while remodels and restoration work are quoted per project. Call (706) 897-8366 for a fast, honest quote.",
  },
  {
    q: "Do you offer same-day and 24/7 emergency service?",
    a: "Yes. Our Emergency Restoration Services are available same-day and 24/7 for water, storm and fire damage. If your home needs urgent help, call us any time and we'll respond quickly.",
  },
  {
    q: "What areas around Blairsville do you serve?",
    a: "We serve a roughly 50-mile radius of zip code 30512 — including Blairsville, Young Harris, Hiawassee, Blue Ridge, Suches, Morganton and McCaysville in North Georgia, plus Murphy, Hayesville, Brasstown and Andrews in North Carolina.",
  },
  {
    q: "Can you extend the life of my roof instead of replacing it?",
    a: "Often, yes. Through targeted repairs, resealing and maintenance we can add years to your existing roof — a cost-effective alternative to a full replacement.",
  },
  {
    q: "Do you handle both small repairs and full remodels?",
    a: "Absolutely. From a single door repair or a fresh coat of paint to complete kitchen, bathroom and basement remodels, we're your one-call local handyman and home services team.",
  },
];
